import { createSlice } from "@reduxjs/toolkit";

const descripcionviajesState = {
  descripcionviajesdata: [],
};

const descripcionviajesSlice = createSlice({
  name: "descripcionviajes",
  initialState: descripcionviajesState,
  reducers: {
    descripcionViajesData: (state, actions) => actions.payload,
    EmptyDescripcionViajesData: () => descripcionviajesState
  },
});

export const { descripcionViajesData, EmptyDescripcionViajesData } = descripcionviajesSlice.actions;

export default descripcionviajesSlice.reducer;
